import { SelectEditor } from "../editors/selectEditor";
import { CreateableSelectEditor } from "../editors/createableSelectEditor";
import { DeploymentStatusSelectEditor } from "../editors/deploymentStatusSelectEditor";
import { DateTimeEditor } from "../editors/dateTimeEditor";
import { dateTimeRenderer } from "../renderers/dateTimeRenderer";
import { associationRenderer } from "../renderers/associationRenderer";
import { safeHTMLRenderer } from "../renderers/safeHTMLRenderer";
import { deploymentStatusRenderer } from "../renderers/deploymentStatusRenderer";
import { coloredRenderer } from "../renderers/coloredRenderer";

const formatUSD = {
  pattern: "0,0.00",
  culture: "en-US",
};

export const pendingColumns = [
  {
    data: "id",
    title: "ID",
    editor: false,
    readOnly: true,
  },
  {
    data: "merchant",
    title: "Merchant",
    url: "/merchants.json",
    editor: CreateableSelectEditor,
    renderer: associationRenderer,
    objectName: "merchant",
    asyncOptions: true,
  },
  {
    data: "mid",
    title: "MID",
    editor: false,
    readOnly: true,
  },
  {
    data: "sales_channel",
    title: "Channel (Agent)",
    url: "/sales_channels.json",
    editor: CreateableSelectEditor,
    renderer: associationRenderer,
    objectName: "sales_channel",
  },
  {
    data: "mid_type",
    title: "MID Type",
    url: "/deployments/mid_types.json",
    editor: SelectEditor,
  },
  {
    data: "application_status",
    title: "App Status",
    url: "/deployments/application_statuses.json",
    editor: SelectEditor,
    renderer: coloredRenderer,
  },
  {
    data: "deployment_status",
    title: "Deployment Status",
    url: "/deployment_statuses.json",
    editor: DeploymentStatusSelectEditor,
    renderer: deploymentStatusRenderer,
  },
  {
    data: "processor",
    title: "Processor",
    url: "/processors.json",
    editor: CreateableSelectEditor,
    renderer: associationRenderer,
    objectName: "processor",
  },
  {
    data: "platform",
    title: "Platform",
    url: "/platforms.json",
    editor: CreateableSelectEditor,
    renderer: associationRenderer,
    objectName: "platform",
  },
  {
    data: "bp_price",
    title: "Pricing",
    type: "numeric",
    numericFormat: formatUSD,
  },
  {
    data: "hardware",
    title: "Hardware",
    renderer: safeHTMLRenderer,
    editor: false,
    readOnly: true,
  },
  {
    data: "in_progress_date",
    title: "Deployment Start Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "deployment_date",
    title: "Hardware Ready Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "delivered_date",
    title: "Delivered Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "payment_form_list",
    title: "Payment Form",
    editor: false,
    readOnly: false,
  },
];
